import { useConfirm } from "primevue/useconfirm";
import { useI18n } from "vue-i18n";

/**
 * useZSDialogs - provides showConfirm and showInfo using ZSDialog component
 * @param {object} zsDialogRef - ref to ZSDialog component (must expose show/hide)
 */
export function useZSDialogs(zsDialogRef) {
	const { t, locale } = useI18n();
    // Helper to show a confirm dialog
    const showConfirm = (title, message, acceptFn, rejectFn, okLabel, cancelLabel) => {
        if (!zsDialogRef?.value?.show) return;
        zsDialogRef.value.show({
            title,
            htmlMessage: message,
            type: 'confirm',
            confirmLabel: okLabel || t('general.yes'),
            cancelLabel: cancelLabel || t('general.no'),
            confirmCallback: acceptFn,
            cancelCallback: rejectFn,
            hideConfirmButton: false,
            hideCancelButton: false,
            hideButtons: false,
            closable: true
        });
    };

    // Helper to show an info dialog
    const showInfo = (title, message, acceptFn, rejectFn) => {
        if (!zsDialogRef?.value?.show) return;
        zsDialogRef.value.show({
            title,
            htmlMessage: message,
            type: 'info',
            confirmLabel: 'Ok',
            hideCancelButton: true,
            hideConfirmButton: false,
            hideButtons: false,
            closable: true,
            confirmCallback: acceptFn,
            cancelCallback: rejectFn
        });
    };

    return { showConfirm, showInfo };
}


export function useDialogs(confirm) {

    confirm = useConfirm();


    const showConfirm = (title, message, acceptFn, rejectFn, okLabel = "Sim", cancelLabel = "Não") => {

        confirm.require({
            message: message,
            header: title,
            icon: "pi pi-exclamation-triangle",
            acceptClass: "flex justify-center",
            acceptLabel: okLabel,
            rejectLabel: cancelLabel,
            accept: () => {
                if (acceptFn) acceptFn();
            },
            reject: () => {
                if (rejectFn) rejectFn();
            },
        });
    };

    const showInfo = (title, message, acceptFn, rejectFn) => {
        confirm.require({
            message: message ?? "",
            header: title,
            icon: "pi pi-exclamation-triangle",
            rejectClass: "hide",
            acceptClass: "flex justify-center",
            acceptLabel: "Ok",
            accept: () => {
                if (acceptFn) acceptFn();
            },
            reject: () => {
                if (rejectFn) rejectFn();
            },
        });
    };
    return { showConfirm, showInfo }
}
